@if(deviceType === 'mobile') { @if(! hasError()) {
<al-loader
  class="loader"
  [text]="
    linkOffStatus() === deepLinkOpeningStatusEnum.success
      ? 'Boa! Ya puede cerrar esta pagina'
      : undefined
  "
></al-loader>
} @else {
<ng-container *ngTemplateOutlet="mobileErrorTemplate"></ng-container>
} } @else {
<div
  class="eva-3-container main-container"
  [ngClass]="{ '-eva-3-hide': isLoading }"
>
  @if(! hasError()) {
  <div class="qr-container -eva-3-no-radius-left">
    <img
      [src]="'images/phone_header.svg' | assetsUrl"
      alt="phone-header"
      class="phone-header"
    />
    <img
      [src]="'images/phone_hand.png' | assetsUrl"
      alt="phone-hand"
      class="phone-hand-img"
    />
    @if(qrData) {
    <qrcode
      #qrElem
      class="-eva-3-hide"
      colorDark="#ffffff"
      colorLight="#4300D2"
      [qrdata]="qrData"
      [width]="235"
      [errorCorrectionLevel]="'H'"
    >
    </qrcode>
    }
    <div class="qr-holder">
      <div class="qr-header-container">
        <ng-container *ngTemplateOutlet="partnerLogoTemplate"></ng-container>
      </div>
      @if(finalQr) {
      <img [src]="finalQr" class="qr-img" alt="qr-code" />
      }
      <div class="qr-hint-container">
        <i class="eva-3-icon-info-circle -eva-3-icon-md"></i>
        <p class="info-text">
          Escaneie com o mesmo aparelho em que você tem o iFood instalado
        </p>
      </div>
    </div>
  </div>
  } @else {
  <ng-container
    *ngTemplateOutlet="
      errorIllustrationTemplate;
      context: { deviceType: deviceType }
    "
  ></ng-container>
  }

  <div class="content-container">
    <h1 class="title eva-3-h1 -primary-4-color">
      {{ title }}
    </h1>
    <p class="eva-3-body-1">
      {{ subtitle }}
    </p>

    @if(! hasError()) {
    <div class="info-container">
      <div class="discounts-container">
        <!-- HOTEL -->
        <div class="discount-item">
          <div class="discount-header -primary-4-color">
            <i class="eva-3-icon-hotels-ui -eva-3-icon-md"></i>
            <span>
              <small>Até<br /></small>
              <strong>25% OFF</strong>
            </span>
          </div>
          <p class="eva-3-body-2">Em hospedagens selecionadas</p>
        </div>

        <!-- CARS -->
        <div class="discount-item">
          <div class="discount-header -primary-4-color">
            <i class="eva-3-icon-cars-ui -eva-3-icon-md"></i>
            <span>
              <small>Até<br /></small>
              <strong>15% OFF</strong>
            </span>
          </div>
          <p class="eva-3-body-2">Em aluguel de carros nos EUA</p>
        </div>

        <!-- INSURANCE -->
        <div class="discount-item">
          <div class="discount-header -primary-4-color">
            <i class="eva-3-icon-assistances-ui -eva-3-icon-md"></i>
            <span>
              <small></small>
              <strong>25% OFF</strong>
            </span>
          </div>
          <p class="eva-3-body-2">Em seguro viagem</p>
        </div>
      </div>
      <h2 class="eva-3-h2 -primary-4-color">Como funciona?</h2>
      <div class="how-it-works-container">
        <!-- QR -->
        <div class="step-item">
          <div class="step-item-header -primary-4-color">
            <i class="eva-3-icon-qr -eva-3-icon-xlg"></i>
            <div class="step-line"></div>
          </div>
          <p class="eva-3-body-1">1. Escaneie o QR Code ao lado</p>
        </div>

        <!-- PHONE -->
        <div class="step-item">
          <div class="step-item-header -primary-4-color">
            <i class="eva-3-icon-cell-phone -eva-3-icon-xlg"></i>
            <div class="step-line"></div>
          </div>
          <p class="eva-3-body-1">
            2. Aguarde enquanto validamos sua conta no app iFood.
          </p>
        </div>

        <!-- CHECK -->
        <div class="step-item">
          <div class="step-item-header -primary-4-color">
            <i class="eva-3-icon-checkmark-circle -eva-3-icon-xlg"></i>
          </div>
          <p class="eva-3-body-1">
            3. Pronto! Seu desconto Clube será liberado 😃
          </p>
        </div>
      </div>
    </div>
    } @else {
    <ng-container *ngTemplateOutlet="errorActionTemplate"></ng-container>
    }
  </div>
</div>
}

<ng-template #partnerLogoTemplate>
  <img
    [src]="'images/ifood_decolar_partnership_logo.svg' | assetsUrl"
    alt="clube-ifood-logo"
    class="club-logo"
  />
</ng-template>

<ng-template #errorIllustrationTemplate let-deviceType="deviceType">
  <div
    class="error-container"
    [ngClass]="{ '-desktop': deviceType !== 'mobile' }"
  >
    <ng-container *ngTemplateOutlet="partnerLogoTemplate"></ng-container>
    <div class="error-illustration"></div>
  </div>
</ng-template>

<ng-template #errorActionTemplate>
  <div class="error-action-container">
    <button
      class="eva-3-btn -lg -primary redirect-button"
      (click)="handleError()"
    >
      <em class="btn-text">{{ actionButtonText }}</em>
    </button>
  </div>
</ng-template>

<ng-template #mobileErrorTemplate>
  <div class="error-container">
    <h5 class="title eva-3-h5 -primary-4-color -eva-3-p-lg">
      {{ title }}
    </h5>
    <p class="eva-3-body-2 -eva-3-pt-sm -eva-3-pl-lg">
      {{ subtitle }}
    </p>
    <div class="-eva-3-p-xlg">
      <ng-container *ngTemplateOutlet="errorActionTemplate"></ng-container>
    </div>
  </div>
</ng-template>
